import { Dispatch } from 'redux';
import { fetchMaintenanceMessage } from './MaintenanceMessage.services';
import {
  SetMaintenanceMessageType,
  SET_MAINTENANCE_MESSAGE,
} from './MaintenanceMessage.types';
import { httpError } from 'common';

const setMaintenanceMessage = (message: string): SetMaintenanceMessageType => ({
  type: SET_MAINTENANCE_MESSAGE,
  message,
});

export const getMaintenanceMessage =
  (bearerToken: string) => (dispatch: Dispatch) => {
    fetchMaintenanceMessage(bearerToken, dispatch)
      .then(httpError(dispatch))
      .then((response: any) => {
        if (response?.messageText) {
          dispatch(setMaintenanceMessage(response.messageText));
        }
      })
      .catch((error) => {
        console.warn(`Maintenance Message`, error.message);
      });
  };
